import { MarketStatus } from "@finbackoffice/enums";
import { IFeedResponseMarket } from "./feed.server.types";

export const getRandomRequestId = (length: number = 20): string => {
  let result = "";
  const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function mergeMarkets(
  marketsMergeInto: IFeedResponseMarket[],
  marketsMergeFrom: IFeedResponseMarket[],
): IFeedResponseMarket[] {
  const storedMarkets: IFeedResponseMarket[] = [...marketsMergeInto];

  for (const market of marketsMergeFrom) {
    const index = storedMarkets.findIndex((m) => m.id === market.id);

    if (index === -1 && market.status === MarketStatus.Open) {
      // add new market
      storedMarkets.push(market);
      continue;
    }

    if (index !== -1 && market.status === MarketStatus.Open) {
      // update market
      storedMarkets.splice(index, 1, market);
      continue;
    }

    if (index !== -1 && market.status !== MarketStatus.Open) {
      // delete all markets with status different from Open
      storedMarkets.splice(index, 1);
      continue;
    }
  }

  return storedMarkets;
}
